import { AlertTriangle } from "lucide-react";
import { arrivedTrailersText, type LegWithArrivedTrailer } from "@/lib/order-trailer-arrival";

/**
 * Warning notice on order surfaces (card, detail page, side sheet) when a
 * leg's trailer was reported at the yard by EAPI and nobody has checked it in
 * and inspected it yet, and that leg's trip hasn't left (see arrivedTrailersText).
 * Pass every leg of the order. Renders nothing otherwise.
 */
export function TrailerArrivedNotice({ legs }: { legs: LegWithArrivedTrailer[] }) {
  const which = arrivedTrailersText(legs);
  if (!which) return null;
  return (
    <div className="flex items-start gap-2 rounded-md border border-amber-500/50 bg-amber-500/10 p-3 text-amber-800 dark:text-amber-200">
      <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
      <div className="flex flex-col gap-0.5 min-w-0">
        <p className="text-sm font-semibold">Trailer arrived, pending check-in</p>
        <p className="text-xs">{which}: at the yard. Check in and inspect at /yard as early as possible.</p>
      </div>
    </div>
  );
}
